
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/powerocean",
      function () {
        return require("private-next-pages/products/powerocean/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/powerocean"])
      });
    }
  